import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import FieldEditor from "components/FieldEditor";
import { FieldError, PersonalClient } from "types";
import * as fields from "pages/clientPortfolio/personalClient/personalClientCreditApp/components/creditAppIdentificationFieldDefinitions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";

type CommonProps = {
  state: PersonalClient;
  setState(state: PersonalClient): void;
  errors: FieldError[];
};

const IdentificationSection = (commonProps: CommonProps) => {
  return (
    <SectionContainer>
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="identificationSection-header"
        >
          <Typography variant={"h6"}>Identification</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FieldEditor<PersonalClient>
                field={fields.clientId}
                {...commonProps}
              />
              <FieldEditor<PersonalClient>
                field={fields.legalFirstName}
                {...commonProps}
              />
              <FieldEditor<PersonalClient>
                field={fields.legalLastName}
                {...commonProps}
              />
              <FieldEditor<PersonalClient>
                field={fields.dateOfBirth}
                {...commonProps}
              />
              <FieldEditor<PersonalClient>
                field={fields.maritalStatus}
                {...commonProps}
              />
              <FieldEditor<PersonalClient>
                field={fields.phoneNumber}
                {...commonProps}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FieldEditor
                field={fields.clientCurrentAddress}
                {...commonProps}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  margin-top: 2em;
`;

export default IdentificationSection;
